export const services = [
  {
    id: 'precision-advertising',
    icon: 'ri-radar-line',
    title: '精准广告投放',
    description: '覆盖Google Ads、Meta Ads、TikTok、Unity Ads等全球主流广告平台，基于AI算法实时优化出价策略与受众定向，最大化广告投放ROI。',
    features: ['跨平台一站式管理', 'AI智能出价优化', '实时数据监控', 'A/B测试自动优化'],
  },
  {
    id: 'data-analytics',
    icon: 'ri-bar-chart-2-line',
    title: '数据分析与归因',
    description: '自研数据引擎追踪全链路用户行为，精准归因各渠道转化效果。实时BI看板让营销决策一目了然，驱动精细化运营。',
    features: ['全链路归因追踪', '实时BI数据看板', '用户行为分析', 'LTV预测模型'],
  },
  {
    id: 'creative-production',
    icon: 'ri-film-line',
    title: '创意素材制作',
    description: '专业创意团队提供本地化素材制作服务，涵盖视频广告、可玩广告、静态素材等多种格式，助力产品在目标市场脱颖而出。',
    features: ['视频广告制作', '可玩广告设计', '本地化创意适配', '素材A/B测试'],
  },
  {
    id: 'user-growth',
    icon: 'ri-user-heart-line',
    title: '用户增长运营',
    description: '从获客到留存全周期用户运营方案，结合社群运营、KOL营销、ASO优化等策略，构建可持续的用户增长飞轮。',
    features: ['全周期用户运营', '社群与KOL营销', 'ASO商店优化', '回流与再营销'],
  },
  {
    id: 'market-research',
    icon: 'ri-global-line',
    title: '海外市场洞察',
    description: '深度研究全球各区域游戏市场趋势、用户偏好与竞争格局，提供定制化出海战略咨询，降低试错成本。',
    features: ['区域市场调研', '竞品深度分析', '用户画像研究', '出海战略咨询'],
  },
  {
    id: 'monetization',
    icon: 'ri-money-dollar-circle-line',
    title: '变现策略优化',
    description: '结合IAP与IAA混合变现模型，基于用户分层定制最优变现路径，平衡用户体验与收入增长。',
    features: ['混合变现模型', '用户分层定价', '广告变现优化', '收入预测分析'],
  },
];